<div class="ui container">
  <div class="ui grid">
    <div class="column">
      <h1>
        Support / FAQ
      </h1>
    </div>
  </div>

  <div class="section">
    <h2>Support with bounties</h2>
    <p>For support with bounties, please visit our
      <a href="https://discord.gg/wFxEaE9">Discord server</a>
      and leave a message in the #bounties channel (or PM
      the site owner 'Mongoose#4167').
    </p>
  </div>
  <div class="section">
    <h2>Frequently asked questions</h2>
    <div class="ui inverted segment">
      <sui-accordion class="inverted">
        <sui-accordion-panel *ngFor="let question of questions">
          <div title>
            <i class="dropdown icon"></i>
            {{ question[0] }}
          </div>
          <div content>
            <p>{{ question[1] }}</p>
          </div>
        </sui-accordion-panel>
      </sui-accordion>
    </div>
  </div>
</div>
